import Ring from "@/components/Ring";

/**
 * The wordmark lockup — the Ring plus "Rammy" in Bricolage.
 * Never all-caps, never with "AI" in the lockup, never on a gradient.
 */
export function Wordmark({ size = 28, className = "", testId = "wordmark" }) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`} data-testid={testId}>
      <Ring state="idle" size={size} showLabel={false} testId={`${testId}-ring`} />
      <span
        className="font-display leading-none"
        style={{
          fontSize: "var(--rm-text-lg)",
          fontWeight: 700,
          letterSpacing: "-0.045em",
          color: "var(--rm-text)",
        }}
      >
        Rammy
      </span>
    </span>
  );
}

export default Wordmark;
